import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { axiosBaseQuery } from "config/axiosBaseQuery";
import {
  BodyHistorialRegistros,
  ResponseActuacionBySistema,
  ResponseHistorialRegistros,
} from "interfaces/expedientes/expedientesInterface";

const baseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost/api/";
interface BodyActuacionesBySistema {
  cveSistema: number;
  idDocumento: number;
  tipo: number;
  cveTipoDoc: number;
  queEs: number;
  consulta: {
    idReferencia: number;
    cveMateria: number;
    cveDocumento: number;
  };
}

export const apiExpedienteElectronico = createApi({
  reducerPath: "expedienteElectronicoApi",
  baseQuery: axiosBaseQuery({
    baseUrl,
  }),
  endpoints(build) {
    return {
      getActuacionesBySistema: build.mutation<
        ResponseActuacionBySistema,
        unknown
      >({
        query: ({
          cveSistema,
          idDocumento,
          tipo,
          cveTipoDoc,
          ...args
        }: BodyActuacionesBySistema) => ({
          url: `actuaciones-pdf/obtener/actuaciones-by-sistema/${cveSistema}/${idDocumento}/${tipo}/${cveTipoDoc}`,
          method: "GET",
          params: { ...args },
        }),
      }),
      postHistorialRegistros: build.mutation<
        ResponseHistorialRegistros,
        unknown
      >({
        query: (payload: BodyHistorialRegistros) => ({
          url: `externos/historial-registros/consultas`,
          method: "POST",
          data: payload,
        }),
      }),
    };
  },
});

export const {
  useGetActuacionesBySistemaMutation,
  usePostHistorialRegistrosMutation,
} = apiExpedienteElectronico;
